<template>
 <user-center-slot>
    <user-center-container-slot>
        <!-- 左侧菜单栏 -->
        <user-center-menu />
        <!-- 右侧内容 -->
          <user-center-content-slot>
            <div class="vul-detail">
              <div class="vul-detail-breadcrumb">
                <xui-breadcrumb separator-class="fa fa-angle-right">
                  <xui-breadcrumb-item :to="{ path: '/usercenter/report' }">漏洞列表</xui-breadcrumb-item>
                  <xui-breadcrumb-item>漏洞详情页</xui-breadcrumb-item>
                </xui-breadcrumb>
              </div>
              <div class="user-center__detail-row">
                <div>
                  <i class="iconfont icon-_biaodan user-center__detail-icon--default"></i>
                </div>
                <div class="user-center__detail-tips">这是<span> {{ data.vulTitle }}</span>的详情</div>
            </div>
              <div>
                <div class="vul-step">
                  <xui-steps :active="active" finish-status="success" align-center>
                    <xui-step v-for="item in title" :key="item.flowStatus" :title="item.flowStatusName"></xui-step>
                  </xui-steps>
                </div>
                <div class="vul-detail-items">
                  <xui-row class="item-line">
                    <xui-col :span="3"><span class="item-title"> 漏洞名称：</span></xui-col>
                    <xui-col :span="3"
                      ><span class="item-value"> {{ data.vulTitle }}</span></xui-col
                      >
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 提交时间：</span></xui-col>
                        <xui-col :span="18"
                          ><span class="item-value">{{ data.creationDate }}</span></xui-col
                          >
                      </xui-row>
                    </xui-col>
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 漏洞编码：</span></xui-col>
                        <xui-col :span="18"
                          ><span class="item-value">{{ data.vulId }}</span></xui-col
                        >
                      </xui-row>
                    </xui-col>
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 漏洞状态：</span></xui-col>
                        <xui-col :span="18"
                          ><span class="item-value">{{ data.displayStatusName }}</span></xui-col
                        >
                      </xui-row>
                    </xui-col>
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 漏洞类型：</span></xui-col>
                        <xui-col :span="18"
                          ><span class="item-value">{{ data.vulTypeName }}</span></xui-col
                        >
                      </xui-row>
                    </xui-col>
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 漏洞等级：</span></xui-col>
                        <xui-col :span="18"
                          ><span class="item-value">{{ data.vulLevelName }}</span></xui-col
                        >
                      </xui-row>
                    </xui-col>
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 漏洞奖金：</span></xui-col>
                        <xui-col :span="18"
                          ><span class="item-value">{{ data.amount }}</span></xui-col
                        >
                      </xui-row>
                    </xui-col>
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 修复版本：</span></xui-col>
                        <xui-col :span="18"
                          ><span class="item-value">{{ data.feedbackFixedVersion }}</span></xui-col
                        >
                      </xui-row>
                    </xui-col>
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="12">
                      <xui-row>
                        <xui-col :span="6"><span class="item-title"> 漏洞附件：</span></xui-col>
                        <xui-col :span="18">
                          <span v-for="(ele, i) in data.attachmentList" :key="i" class="attachment_uploadFile">
                                <span> <i class="fa fa-file"></i> </span>
                                <xui-link :key="index" :href="jumpUrl(ele)" class="attachment_uploadFile_xui-link" :disabled="ele.disabled" type="primary" target="_blank"
                                  :title="ele.docName">
                                  {{ docNameHandle(ele.docName) }} <span class="attachment_uploadFile_span">{{ ele.uploadMsg }}</span></xui-link
                                >
                              </span>
                        </xui-col>
                      </xui-row>
                    </xui-col>
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="3"><span class="item-title"> 漏洞详情：</span></xui-col>
                    <xui-col :span="21">
                      <xui-row class="detail-html item-value-left">
                        <p class="QRCode" v-html="data.content">
                          {{ data.content }}
                        </p>
                      </xui-row>
                    </xui-col>
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="3"><span class="item-title">处理记录：</span></xui-col>
                    <xui-col :span="21">
                      <div v-for="item in data.approveRecordList" :key="item.approveTime" class="vulLogs-line">
                        <!-- <div>2021/09/08 09:25:45 [已受理] : 感谢您的提交，漏洞已受理。</div> -->
                        <div v-if="data.closeReasonName && item.flowStatus === 10">
                          {{ item.approveTime + '[' + item.flowStatusName + '] : 感谢您的提交，当前漏洞为' + data.closeReasonName + '，' + item.flowStatusName }}
                        </div>
                        <div v-else>{{ item.approveTime + '[' + item.flowStatusName + '] : 感谢您的提交，漏洞' + item.flowStatusName }}</div>
                        <div class="xui-divider xui-divider--horizontal"></div>
                      </div>
                    </xui-col>
                  </xui-row>

                  <xui-row class="item-line">
                    <xui-col :span="3"><span class="item-title"> 留言记录：</span></xui-col>
                    <xui-col :span="21">
                      <div class="vulLogs-line">
                        <xui-row v-for="item in data.vulBbsReturnVOList" :key="item.status" class="row">
                          <xui-col :span="4">
                            <img
                              v-if="item.isAdmin === 0 && $baseU"
                              :src="'https://' + $baseU + '.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=' + pictureUrl"
                              class="avatar"
                            />
                            <img v-else-if="$baseU" :src="'https://' + $baseU + '.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/res/image?attachmentId=' + $defaultAvatar" class="avatar" />
                          </xui-col>
                          <xui-col :span="12">
                            <xui-row class="commLogs-user">{{ item.bbsUser }}</xui-row>
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <xui-row class="commLogs-content" style="word-wrap: break-word;word-break: break-all;line-break: anywhere;"> <div v-html="item.content"></div></xui-row>
                            <xui-row style="margin-bottom:10px">
                              <span v-for="(ele, i) in item.s3AttachmentVOList" :key="i" class="s3Attachment_uploadFile">
                                <span> <i class="fa fa-file"></i> </span>
                                <xui-link :key="index" :href="jumpUrl(ele)" class="attachment_uploadFile_xui-link" :disabled="ele.disabled" type="primary" target="_blank"
                                  :title="ele.docName">
                                  {{ docNameHandle(ele.docName) }} <span class="attachment_uploadFile_span">{{ ele.uploadMsg }}</span></xui-link
                                >
                              </span>
                            </xui-row>
                          </xui-col>
                          <xui-col :span="8" class="commLogs-time">
                            <xui-row>{{ item.creationDate }}</xui-row>
                          </xui-col>
                        </xui-row>
                        <div class="xui-divider xui-divider--horizontal"></div>
                      </div>
                    </xui-col>
                  </xui-row>

                  <xui-form v-if="isShowByStatus" ref="ruleForm" :model="ruleForm" :rules="rules">
                    <xui-row class="item-line">
                      <xui-col :span="3"><span class="item-title"> 发表留言：</span></xui-col>
                      <xui-col :span="21">
                        <xui-form-item class="item-value-left" prop="message">
                          <xui-input v-model.trim="ruleForm.message" type="textarea" :maxlength="2000" aria-placeholder="有异议的时候，在这里写内容，然后提交" style="height:180px" />
                        </xui-form-item>
                      </xui-col>
                    </xui-row>

                    <xui-row v-if="isShowByStatus" class="item-line">
                      <xui-col :span="3"><span class="item-title"> 上传附件：</span></xui-col>
                      <xui-col :span="21">
                        <xui-form-item v-model="ruleForm.fileList" class="item-value-left">
                          <div class="upload-attachment">
                            <xui-upload
                              class="upload-demo"
                              :action="action"
                              :headers="xCsrfToken"
                              accept=".zip,.7z,.rar"
                              :before-upload="beforUploadZip"
                              :on-remove="resetFile"
                              :on-exceed="handleExceed"
                              :on-error="reportError"
                              :limit="1"
                              :on-success="handlePreviewZip"
                              :file-list="ruleForm.fileList"
                              :with-credentials="true"
                            >
                              <xui-button size="medium">选择文件</xui-button>
                              <div slot="tip" class="xui-upload__tip">
                                格式限制:7z,rar,zip格式,不超过200M。 <span v-if="uploadMsg" class="upload-msg"> {{ uploadMsg }} </span>
                              </div>
                            </xui-upload>
                          </div>
                        </xui-form-item>
                      </xui-col>
                    </xui-row>
                    <xui-row v-if="isShowByStatus" class="is-justify-center xui-row--flex">
                      <xui-button id="submitButton" :disabled="submitDisabled" class="xui-button--primary is-round" @click="submitInfo('ruleForm')"><span>提交</span></xui-button>
                    </xui-row>
                  </xui-form>
                </div>
              </div>
            </div>
          </user-center-content-slot>
    </user-center-container-slot>
    <!-- 荣耀安全应急响应中心服务条款弹框 -->
    <xui-dialog title="" class="warnning-wrap" :close-on-click-modal="false" showcenter :visible.sync="dialogVisible" :width="$store.state.isMobile ? '80%': '30%'" :before-close="handleClose">
      <h3 :style="{'font-size': $store.state.isMobile ? '24px': '16.5px'}">荣耀安全应急响应中心服务条款</h3>
      <div class="content-wrap" :style="{'font-size': $store.state.isMobile ? '22px': '14px'}">
        <p>欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:</p>
        <ul>
          <li>真实姓名，身份证正反面照片及身份证号；</li>
          <li>银行卡号，开户行信息，银行名称；</li>
          <li>手机号码，邮寄地址；</li>
          <li>昵称，头像，邮箱，主页；</li>
          <li>QQ，微信，签名，团队；</li>
          <li>IP地址；</li>
          <li>为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；</li>
        </ul>
        <p>上述数据将会传输并保存至位于中华人民共和国境内的服务器。</p>
        <span
          >点击“同意”，即表示您同意
          <a :href="safetyURL" target="_blank" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</a>
          ，并知悉
          <a :href="privacyURL" target="_blank" class="honor-security-secret-statement">关于安全应急响应中心与隐私的声明</a>。</span
        >
      </div>
      <span slot="footer" center>
        <xui-button size="bigger" @click="handleClose">取消</xui-button>
        <xui-button type="primary" size="bigger" @click="confirm">同意</xui-button>
      </span>
    </xui-dialog>
    <!-- 登录提示弹框 -->
    <xui-dialog v-if="isNotLogin && isEffect" title="失效提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>您的账号已经失效，请联系管理员</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="handleClose">返回首页</xui-button>
      </span>
    </xui-dialog>
    <xui-dialog v-else title="登录提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>系统检测到您未登录或登录失效，请先登录</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="login">荣耀账号登录</xui-button>
      </span>
    </xui-dialog>
  </user-center-slot>
</template>
<script>
import UserCenterMenu from '../../../components/pages/UserCenterMenu'
import UserCenterContainerSlot from '../../../components/pages/UserCenterContainerSlot'
import UserCenterSlot from '../../../components/pages/UserCenterSlot'
import UserCenterContentSlot from '../../../components/pages/UserCenterContentSlot'
import router from '../../../router/index.js';
import { v4 } from 'uuid';
import store from '../../../store/index'
import { mapState } from 'vuex';

const arrMsg = [
  '您上传的文件无病毒',
  '检测到上传的附件存在病毒',
  '您上传的文件文件加密',
  '',
  '当前杀毒云系统扫描存在异常，可能原因为压缩包存在密码，建议下载文件后进行手工查杀'
];
export default {
  name: 'usercenterReportDetail',
  components: {
    UserCenterMenu,
    UserCenterSlot,
    UserCenterContainerSlot,
    UserCenterContentSlot,
  },
    computed: {
    ...mapState(['unReadBbsCount', 'unReadMsgListCount'])
  },
  data() {
    return {
      safetyURL: '',
      privacyURL: '',
      submitDisabled: false,
      isEffect: false,
      dialogVisible: false,
      xCsrfToken: null,
      status: '0',
      currentPage: 1,
      pageSize: 9,
      active: 1,
      isNotLogin: false,
      moveable: false,
      action: this.$baseURL + 'vul/hsrc/vul/report/servlet/uploadFile?ulType=VulUploadAttach&dir=VulAttach&businessType=VUL_BBS', // 上传附件，压缩包vulId
      ruleForm: {
        content: '',
        vulId: '',
        attachmentId: '',
        message: ''
      },
      rules: {
        message: [{ required: true, message: '输入不能为空', trigger: 'blur' }]
      },
      data: [],
      title: [],
      uploadMsg: '',
      pollingDataInterval: null,
      displayName: '',
      pictureUrl: '',
      isShowByStatus: true
    };
  },
  beforeCreate() {
    // console.log('beforeCreate---this', this);
  },
  created() {
    // console.log('created---this', this);
    // console.log('bbb', this.$baseU);
    // console.log('=================', Vue.http.interceptors.push());
  },
  mounted() {
    setTimeout(() => {
      this.getCSRF();
      this.getUserInfo();
      this.safetyURL = window.sessionStorage.getItem('safetyURL');
      this.privacyURL = window.sessionStorage.getItem('privacyURL');
    }, 100);
  },
  beforeDestroy() {
    if (this.pollingDataInterval) {
      clearInterval(this.pollingDataInterval);
    }
  },
  methods: {
    resetFile() {
      if(this.pollingDataInterval){
        clearInterval(this.pollingDataInterval);
      }
      this.ruleForm.attachmentId = '';
      this.uploadMsg = '';
      this.submitDisabled = false;
    },
    reportError(err) {
      const callError = JSON.parse(err.message);
      this.$message.error(callError.message||'上传失败，请稍后再试！');
    },
    isPro() {
      const HOST = window.location.host;
      const HOST_UAT = 'hsrc-uat.test.honor.com';
      const HOST_DEV = 'localhost.honor.com:8080';
      return !(HOST === HOST_UAT || HOST === HOST_DEV);
    },
    getDetail() {
      const vulId = this.$route.query.vulId;
      const Token = window.sessionStorage.getItem('x-csrf-token');
      const s = new Promise((resolve, reject) => {
        this.$http.post(`vul/hsrc/vul/report/services/vul/single/${vulId}`, { headers: { 'x-csrf-token': Token } }).then(res => {
          if (res && res.data && res.data.data) {
            this.changeVuexInfo();
            res.data.data.content = this.xssDefend(res.data.data.content);
            if (this.isPro()) {
              res.data.data.content = res.data.data.content.replace(
                'https://security.hihonor.com',
                'https://security.honor.com'
              );
            } else {
              res.data.data.content = res.data.data.content.replace(
                'https://hsrc-uat.itsec.hihonor.com',
                'https://hsrc-uat.test.honor.com'
              );
            }
            res.data.data.approveRecordList.sort(function(x, y) {
              if (x.flowStatus > y.flowStatus) {
                return 1;
              } else if (x.flowStatus < y.flowStatus) {
                return -1;
              } else {
                return 0;
              }
            });
            this.data = res.data.data;
            if (this.data && this.data.vulBbsReturnVOList && this.data.vulBbsReturnVOList.length) {
              this.data.vulBbsReturnVOList.map(async e => {
                e.content = e.content.replace(/\n/g, '<br/>');
                e.content = await this.xssDefend(e.content);
              });
            }
            this.data.status === 6 || this.data.status === 10 ? (this.isShowByStatus = false) : (this.isShowByStatus = true);
            this.title = [];
            for (const t of this.data.approveRecordList) {
              const item = {};
              item.flowStatus = t.flowStatus;
              item.flowStatusName = t.flowStatusName;
              this.title.push(item);
            }
            /* this.title.sort(function (x, y) {
              if (x.flowStatus > y.flowStatus) {
                return 1;
              } else if (x.flowStatus < y.flowStatus) {
                return -1;
              } else {
                return 0;
              }
            }); */
            switch (this.title[this.title.length - 1].flowStatus) {
              case 1:
                this.active = 1;
                this.title.push({ flowStatus: 4, flowStatusName: '待确认' });
                this.title.push({ flowStatus: 6, flowStatusName: '待奖金支付' });
                this.title.push({ flowStatus: 10, flowStatusName: '待关闭' });
                break;
              case 2:
                this.active = 1;
                this.title.push({ flowStatus: 4, flowStatusName: '待确认' });
                this.title.push({ flowStatus: 6, flowStatusName: '待奖金支付' });
                this.title.push({ flowStatus: 10, flowStatusName: '待关闭' });
                break;
              case 4:
                this.active = 2;
                this.title.push({ flowStatus: 6, flowStatusName: '待奖金支付' });
                this.title.push({ flowStatus: 10, flowStatusName: '待关闭' });
                break;
              case 6:
                this.active = 3;
                this.title.push({ flowStatus: 10, flowStatusName: '待关闭' });
                // this.isShowByStatus = false
                break;
              case 10:
                this.title.length === 2 ? (this.active = 4) : (this.active = 4);
                // this.isShowByStatus = false
                break;

              default:
                break;
            }
            if (this.data.flowStop) {
              this.title = [];
              this.title.push({ flowStatus: 1, flowStatusName: '已受理' });
              this.title.push({ flowStatus: 10, flowStatusName: '已关闭' });
              this.active = 2;
            }
          }
        });
      });
    },
    // 关闭登录弹框
    handleClose: function() {
      this.$router.push({ path: '/' });
    },
    changeVuexInfo: function() {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            if (res.data && res.data.status === 200) {
                  store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
                  store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
                  store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
            } 
          })
    },
    // 确实是否登录
    getUserInfo: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            if (res.data && res.data.status === 200) {
               this.getDetail();
              this.displayName = res.data.data.displayName;
              this.pictureUrl = res.data.data.headPictureUrl;
              // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
              // 如果是登录状态，就验证是否签名
              // this.query();
              // 确认是否完善个人信息
              if (res.data.data && res.data.data.bankCard && res.data.data.idCard) {
                this.completeFlag = true;
              } else {
                this.completeFlag = false;
              }
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            console.log(error);
            if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
              this.isEffect = true;
              this.isNotLogin = true;
            }
          });
      });
    },
    // 确认个人签名
    confirm: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/save', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 保存成功后，放开修改
            if (res.status === 200) {
              this.dialogVisible = false;
            } else {
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    query() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/query', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 接口直接返回布尔值，false时为未签名，弹出签名窗
            if (!res.data) {
              this.dialogVisible = true;
            } else {
              this.dialogVisible = false;
              // 为true时，为签名验证已过，不需要签名
              // 已签名状态，就初始化验证码和奖励计划
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    getCSRF: function() {
      const that = this;
      const options = {
        withCredentials: true,
        headers: {
          'x-csrf-token': null
        }
      };

      const s = new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', {
            headers: {
              'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
              appid: this.$appId,
              'x-celon-admin': true,
              'x-sub-app-id': 'hsrc_vul',
              'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
          })
          .then(res => {
            that.xCsrfToken = { 'x-csrf-token': res['headers']['x-csrf-token'] };
            window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    login: function() {
      this.loginHandle();
    },
    // 点击登录
    loginHandle: function() {
      let client_id = '',
        login_channel = '',
        req_client_type = '',
        redirect_uri = '',
        scope = '';
      for (let metas = document.getElementsByTagName('meta'), i = 0; i < metas.length; ++i) {
        switch (metas[i].name) {
          case 'client_id':
            client_id = metas[i].content;
            break;
          case 'login_channel':
            login_channel = metas[i].content;
            break;
          case 'req_client_type':
            req_client_type = metas[i].content;
            break;
          case 'redirect_uri':
            redirect_uri = metas[i].content;
            break;
          case 'scope':
            scope = metas[i].content;
            break;
          default:
            break;
        }
      }
      const stautusData = v4();
      const authURL = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/oauth2/v3/authorize?' : 'https://hnoauth-login-test-drcn.cloud.honor.com/oauth2/v3/authorize?';
      const redirectUrl =
        authURL +
        'response_type=code&access_type=offline&state=' +
        stautusData +
        '&client_id=' +
        client_id +
        '&login_channel=' +
        login_channel +
        '&req_client_type=' +
        req_client_type +
        '&redirect_uri=' +
        redirect_uri +
        '&scope=' +
        scope;

      window.location.href = redirectUrl;
    },
    // 上传附件成功
    handlePreviewZip(file) {
      console.log('handlePreviewZip')
      this.uploadMsg = '您上传的文件正在扫描中';
      const Token = window.sessionStorage.getItem('x-csrf-token');
      this.ruleForm.attachmentId = file[0];
      this.pollingDataInterval = setInterval(() => {
        this.$http
          .get(`vul/hsrc/vul/report/services/filetask/single?attachmentId=${file[0]}`, { headers: { 'x-csrf-token': Token } })
          .then(res => {
            if (res.data && res.data.status === 200) {
              const data = res.data.data;
              if (Number(data) > 5) {
                 console.log("已扫描超过五次")
              } else {
                arrMsg.forEach((e, i) => {
                  if (Number(data) === i + 1) {
                    this.uploadMsg = e;
                  }
                });
                if(this.uploadMsg === '检测到上传的附件存在病毒'){
                  this.submitDisabled = true;
                } else {
                  this.submitDisabled = false;
                }
                clearInterval(this.pollingDataInterval);
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }, 20000);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传 1 个文件，如果需要重新上传，请先删除原先文件`);
    },
    // 上传附件之前
    beforUploadZip(file) {
      const testmsg = (file.name.substring(file.name.lastIndexOf('.') + 1)).toLowerCase();
      const extension = testmsg === 'zip' || testmsg === '7z' || testmsg === 'rar';
      const isList10M = file.size / 1024 / 1024 < 200;
      let bool = false;

      if (extension) {
        bool = true;
      } else {
        bool = false;
      }

      if (!extension) {
        this.$message.warning('上传文件只能是7z,rar,zip格式');
      }
      if (!isList10M) {
        this.$message.warning('上传文件大小不能超过 200M!');
      }

      return bool && isList10M;
    },
    submitInfo(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          const s = new Promise((resolve, reject) => {
            this.$http
              .get('vul/hsrc/vul/report/services/user/getUserInfo')
              .then(res => {
                if (res.data && res.data.status === 200) {
                  // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
                  store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
                  store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
                  store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
                  // 登陆状态校验通过后，校验验证码状态
                  return true;
                } else {
                  this.isNotLogin = true;
                  return false;
                }
              })
              .catch(error => {
                console.log(error);
              });
          });

          if (s) {
            const vulId = this.$route.query.vulId;
            const Token = window.sessionStorage.getItem('x-csrf-token');
            const message = this.xssDefend(this.ruleForm.message);
            this.ruleForm.vulId = vulId;
            this.ruleForm.content = message;
            this.$http
              .post(`vul/hsrc/vul/report/services/vul/edit`, this.ruleForm, { headers: { 'x-csrf-token': Token } })
              .then(res => {
                if (res && res.status === 200) {
                  window.location.reload();
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        } else {
          console.log('error submit!!');
          return true;
        }
      });
    },
    xssDefend(str) {
      if (typeof str !== 'string') {
        return '';
      }
      const html = window.filterXSS(str, {
        whiteList: {
          table: ['width', 'border', 'align', 'valign'],
          tbody: ['align', 'valign', 'text-align'],
          td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          tfoot: ['align', 'valign'],
          th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
          thead: ['align', 'valign', 'text-align'],
          tr: ['rowspan', 'align', 'valign', 'text-align'],
          tt: [],
          a: ['target', 'href', 'title'],
          abbr: ['title'],
          address: [],
          area: ['shape', 'coords', 'href', 'alt'],
          article: [],
          aside: [],
          b: [],
          bdi: ['dir'],
          bdo: ['dir'],
          big: [],
          blockquote: ['cite'],
          br: [],
          caption: [],
          center: [],
          cite: [],
          code: [],
          col: ['align', 'valign', 'span', 'width'],
          colgroup: ['align', 'valign', 'span', 'width'],
          dd: [],
          del: ['datetime'],
          details: ['open'],
          div: [],
          dl: [],
          dt: [],
          em: [],
          font: ['color', 'size', 'face'],
          footer: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          header: [],
          hr: [],
          i: [],
          img: ['src', 'alt', 'title', 'width', 'height'],
          ins: ['datetime'],
          li: [],
          mark: [],
          nav: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          section: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: [],
          p: ['style'],
          strong: ['style'],
          span: ['style'],
          br: [],
          img: ['style', 'src', 'border', 'width', 'height']
        },
        stripIgnoreTag: true, // 过滤所有非白名单标签的HTML
        stripIgnoreTagBody: ['script', 'iframe'] // script标签较特殊，需要过滤标签中间的内容
      });
      return html;
    },
    selectHandle: (index, indexPath) => {
      if (index === '1') {
        router.push({ path: '/usercenter/info' });
      }
      if (index === '2') {
        router.push({ path: '/usercenter/idinfo' });
      }
      if (index === '3') {
        router.push({ path: '/usercenter/report' });
      }
      if (index === '4') {
        router.push({ path: '/usercenter/sitemsg' });
      }
      if (index === '5') {
        router.push({ path: '/usercenter/teamMenu' });
      }
    },
    handleRow(row, event, column) {
      this.$router.push({ path: '/usercenter/report/detail', query: { code: row.code } });
    },

    // 上传成功钩子
    handleSuccess(response, file, fileList) {
      console.log('handleSuccess', fileList);
    },

    handleRequest(param) {
      // param包含了对upload上传文件 success 成功钩子，error 失败钩子，progress 上传进度钩子
      // 主动调用这些钩子以实现相应功能（注意自己调用钩子时候保证回调参数一致）。
      console.log('param', param);
      const isJPG = param.file.type === 'image/jpeg';
      const isPNG = param.file.type === 'image/png';

      if (!(isJPG || isPNG)) {
        // 上传失败手动触发文件上传失败时的钩子
        param.onError();
        this.$notify.error({
          title: '错误',
          message: '上传格式只能是 JPG/PNG 格式!',
          duration: 2000
        });
        return false;
      }

      // 处理上传进度
      const onProgress = function(event) {
        param.file.percent = (event.loaded / event.total) * 100;
        // 手动触发上传进度的钩子
        param.onProgress(param.file);
      };

      this.mockRequest(param.file, onProgress)
        .then(res => {
          // 上传成功手动触发文件上传成功时的钩子
          param.onSuccess();
        })
        .catch(res => {
          // 上传失败手动触发文件上传失败时的钩子
          param.onError();
        });
    },

    // 模拟文件上传
    mockRequest(param, onProgress) {
      return new Promise((resolve, reject) => {
        const event = {
          total: 3000,
          loaded: 0
        };
        const timer = setInterval(() => {
          event.loaded += 500;
          if (onProgress && typeof onProgress === 'function') {
            onProgress(event);
          }
          if (event.loaded >= event.total) {
            clearInterval(timer);
            resolve('success');
          }
        }, 200);
      });
    },
    jumpUrl(item) {
      if (item.uploadMsg) {
        return item.junpFileUrl;
      }
      let disabled = false;
      item.disabled = true;
      let url = 'javascript:;';
      const Token = window.sessionStorage.getItem('x-csrf-token');
      this.$http.get(`vul/hsrc/vul/report/services/filetask/single?attachmentId=${item.attachmentId}`, { headers: { 'x-csrf-token': Token } }).then(res => {
        if (res && res.data && res.data.status === 200) {
          const data = res.data.data;
          let uploadMsg = '';
          if (Number(data) > 5) {
            disabled = true;
            uploadMsg = '您上传的文件正在扫描中';
          } else {
            arrMsg.forEach((e, i) => {
              if (Number(data) === i + 1) {
                uploadMsg = e;
              }
            });
            if (uploadMsg === '检测到上传的附件存在病毒') {
              disabled = true;
              this.submitDisabled = true;
            } else {
              disabled = false;
              this.submitDisabled = false;
              url = `https://${this.$baseU}.honor.com/hsrc/vul/gateway/vul/hsrc/vul/report/servlet/download?dlType=VulDownLoadFiles&attachmentId=${item.attachmentId}`;
            }
          }
          item.uploadMsg = `${uploadMsg}`;
          item.junpFileUrl = url;
          item.disabled = disabled;
          this.$forceUpdate();
        }
      });
      return url;
    },
    docNameHandle: function(val) {
      // eslint-disable-next-line no-magic-numbers
      if(val && val.length > 10){
        return val.substring(0, 10) + '……';
      }
      return val
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../../global/variable';
.warnning-wrap {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  h3 {
    text-align: center;
  }
  .content-wrap {
    padding: 60px 10px;
    ul {
      padding-left: 20px;
    }
    span a {
      text-decoration: none;
    }
  }
  .xui-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff !important;
      border-color: #66b1ff;
      color: #fff;
    }
  }
}
  .vul-detail {
    font-size: 0.75rem;
    .vul-detail-breadcrumb {
        padding: 40px 0 20px 50px;
        border-bottom:1px solid var(--src-color-secondary-light5);
        font-size: var(--src--text-size-large-extra3);
        color: var(--src-color-primary-deep);
        font-weight: var(--src-text-weight-dark1);
      .xui-breadcrumb {
        font-size: 14px;
        line-height: 1;
        .xui-breadcrumb__item {
          height: 2rem;
          line-height: 2rem;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          .xui-breadcrumb__inner {
            padding: 0 0.25rem;
            font-size: 0.8rem;
            .cur-breadcrumb {
              font-size: 0.9rem;
              font-weight: bold;
            }
          }
        }
      }
    }
    .vul-step {
      font-size: 0.75rem;
    }
    .vul-detail-items {
      padding: 1rem 110px;
      .item-line {
        margin: 1.25rem 0;
        .detail-html {
          padding: 0.5rem;
          text-align: justify;
          word-break: break-all;
          max-width: 100%;
          /deep/ p {
            margin: 0 0;
            font-size: 13px;
            line-height: 2;
            text-align: justify;
          }
          /deep/img {
            width: auto;
            max-width: 100%;
          }
          /deep/td,
          th {
            padding: 5px 10px;
            border: 1px solid #666;
            line-height: initial;
            text-align: left;
          }
          /deep/table {
            margin: 1rem 0;
            border-collapse: collapse;
            display: table;
            width: 100%;
          }
        }
        .vulLogs-line {
          font-size: 0.8rem;
          line-height: 1.5rem;
          .xui-divider--horizontal {
            margin: 0.8rem 0 0 0;
          }
          .el-divider {
            background-color: #ebeef5;
          }
          .commLogs-time {
            font-size: 0.7rem;
            padding: 0.5rem 0;
            line-height: 1rem;
            text-align: right;
            padding-right: 1rem;
          }
          .commLogs-content {
            font-size: 0.7rem;
            line-height: 1rem;
            word-break: break-all;
            word-spacing: normal;
          }
          .avatar {
            width: 2.2rem;
            height: 2.2rem;
          }
          .commLogs-user {
            font-size: 0.7rem;
            padding: 0 0 0.5rem 0;
            line-height: 1rem;
          }
        }
        .vulLogs-line:last-child {
          padding: 0;
        }
        .item-title {
          color: var(--src-color-secondary-light6);
          font-weight: var(--src-text-weight-light1);
        }
        .item-value {
          font-weight: 500;
          word-break: break-all;
        }
        .upload-msg {
          position: absolute;
          left: 240px;
          top: 45px;
          color: green;
        }
      }
    }
  }
/deep/.xui-breadcrumb .xui-breadcrumb__item:nth-child(1) .xui-breadcrumb__inner {
  padding: 0 0.25rem;
  font-size: 0.8rem;
  text-decoration: none;
  color: #000000;
}
/deep/.xui-breadcrumb .xui-breadcrumb__item:nth-child(2) .xui-breadcrumb__inner {
  font-size: 0.9rem;
  font-weight: bold;
  text-decoration: none;
  color: #000000;
}
/deep/.xui-menu .switcher {
  display: none;
}
/deep/.xui-menu-item:hover {
  border-left: solid 0.3rem #409eff !important;
  background-color: #eee !important;
  color: #409eff !important;
}
/deep/.xui-step__head.is-success .xui-step__line {
  border-color: #8aba53;
}
/deep/.xui-textarea__inner {
  height: 100%;
  resize: none;
}
/deep/.xui-upload__tip {
  color: #606266;
  font-weight: 600;
}
/deep/.xui-button.is-round {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  border-radius: 20px;
  padding: 12px 23px;
  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
  }
}
/deep/table td {
  display: table-cell !important;
  vertical-align: inherit !important;
  border: 1px solid #000 !important;
  padding: 2px 5px !important;
  outline: none !important;
}
/deep/table {
  border-collapse: collapse !important;
  width: 100%;
}
.row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;
}
/deep/.dialog-footer {
  span {
    color: #fff;
    font-size: 14px;
    font-weight: normal;
  }
  .right span {
    color: #333;
  }
}
.login-dialog {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}

//22919统一样式
.user-center__detail-row{
  display:flex;
  align-items: center;
  padding: 20px 50px;
  border-bottom: 1px solid var(--src-color-secondary-light5);
}
.user-center__detail-icon--default{
  display: inline-block;
  width: 84px;
  height: 84px;
  line-height: 84px;
  border-radius: 50%;
  font-size: var(--src--text-size-large-extra10);
  background: var(--src-bg-color-dark1);
  text-align: center;
  color: var(--src-text-color-white);
}
.user-center__detail-tips{
  margin-left: 20px;
  cursor: pointer;
}
.attachment_uploadFile{
  border: 1px solid #e2e2e2;
  display:inline-block;
  padding:0 5px;
}
.attachment_uploadFile_xui-link{
  margin-left:5px;
  margin-top:5px;
  display:inline-block;
}
.attachment_uploadFile_span{
  margin-left:10px;
  color:red;
}
.s3Attachment_uploadFile{
  border: 1px solid #e2e2e2;
  display:inline-block;
  padding:0 5px;
  margin-top:30px;
}

@media only screen and (max-width: 1180px) {
  .vul-detail .vul-detail-items{
    padding:1rem 90px;
  }

}

@media only screen and (max-width: 1150px) {
  .vul-detail .vul-detail-items{
    padding:1rem 80px;
  }
}


@media only screen and (max-width: 1100px) {
  .vul-detail .vul-detail-items{
    padding:1rem 73px;
  }

  .vul-detail .xui-row{
    display: flex;
    overflow:hidden;
  }

  .vul-detail .xui-row .xui-col-3:first-child,
  .vul-detail .xui-row .xui-col-6{
    min-width: 72px;
  }

  .vul-detail .xui-row .xui-col-6 + div{
    flex: 1;
  }
}

@media only screen and (max-width: 1000px) {
  .vul-detail .vul-detail-items{
    padding:1rem 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/report/UsercenterReportDetail.vue